export default {
  SET_INSTRUMENT_CATEGORIES(state, data) {
    state.instrumentCategories = data
  },
  SET_CHARACTER_MODEL(state, data) {
    state.instrumentsStateModel = data
  },
  SET_CHARACTER_MODEL_VARIANT(state, data) {
    state.instrumentsStateModelVariant = data
  },
  SET_INSTRUMENT_REMAINS(state, data) {
    state.instrumentRemains = data
  },
  SET_INSTRUMENTS_FOR_ENTERING(state, data) {
    state.instrumentsForEntering = data
  },

  SET_INSTRUMENTS_MODAL_DETAILS(state, data) {
    state.instrumentModalDetails = data
  },

  SET_INSTRUMENTS_REMAINS_BUILDERS(state, data) {
    state.instrument_for_builds = data
  },
}
